// @generated by protoc-gen-es v1.10.1 with parameter "target=ts,import_extension=none"
// @generated from file mono/datagateway/v1/pursuit_pp.proto (package mono.datagateway.v1, syntax proto3)
/* eslint-disable */ // @ts-nocheck
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { Message, proto3 } from "@bufbuild/protobuf";
/**
 * @generated from message mono.datagateway.v1.PursuitPPMetric
 */ export class PursuitPPMetric extends Message {
    static fromBinary(bytes, options) {
        return new PursuitPPMetric().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PursuitPPMetric().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PursuitPPMetric().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(PursuitPPMetric, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string measured_thing = 1;
   */ _define_property(this, "measuredThing", ""), /**
   * Text preserves precision and unknown values; no numeric default is inferred.
   *
   * @generated from field: string value = 2;
   */ _define_property(this, "value", ""), /**
   * @generated from field: string unit = 3;
   */ _define_property(this, "unit", ""), /**
   * @generated from field: string period = 4;
   */ _define_property(this, "period", ""), /**
   * @generated from field: string baseline = 5;
   */ _define_property(this, "baseline", ""), /**
   * @generated from field: string source = 6;
   */ _define_property(this, "source", ""), /**
   * unknown | pending | restricted. A manual claim cannot self-approve reuse.
   *
   * @generated from field: string reuse_status = 7;
   */ _define_property(this, "reuseStatus", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(PursuitPPMetric, "runtime", proto3);
_define_property(PursuitPPMetric, "typeName", "mono.datagateway.v1.PursuitPPMetric");
_define_property(PursuitPPMetric, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "measured_thing",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "value",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "unit",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "period",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "baseline",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "source",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "reuse_status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.PursuitPPComparison
 */ export class PursuitPPComparison extends Message {
    static fromBinary(bytes, options) {
        return new PursuitPPComparison().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PursuitPPComparison().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PursuitPPComparison().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(PursuitPPComparison, a, b);
    }
    constructor(data){
        super(), /**
   * scope | customer | scale | capabilities | needs
   *
   * @generated from field: string dimension = 1;
   */ _define_property(this, "dimension", ""), /**
   * @generated from field: string pursuit_context = 2;
   */ _define_property(this, "pursuitContext", ""), /**
   * @generated from field: string reference_context = 3;
   */ _define_property(this, "referenceContext", ""), /**
   * match | difference | missing_evidence. Always a manual assessment, no verdict.
   *
   * @generated from field: string assessment = 4;
   */ _define_property(this, "assessment", ""), /**
   * @generated from field: string source = 5;
   */ _define_property(this, "source", ""), /**
   * @generated from field: string missing_evidence = 6;
   */ _define_property(this, "missingEvidence", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(PursuitPPComparison, "runtime", proto3);
_define_property(PursuitPPComparison, "typeName", "mono.datagateway.v1.PursuitPPComparison");
_define_property(PursuitPPComparison, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "dimension",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "pursuit_context",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "reference_context",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "assessment",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "source",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "missing_evidence",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.PursuitPPContent
 */ export class PursuitPPContent extends Message {
    static fromBinary(bytes, options) {
        return new PursuitPPContent().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PursuitPPContent().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PursuitPPContent().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(PursuitPPContent, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string narrative = 1;
   */ _define_property(this, "narrative", ""), /**
   * @generated from field: string outcomes = 2;
   */ _define_property(this, "outcomes", ""), /**
   * @generated from field: repeated string scope_examples = 3;
   */ _define_property(this, "scopeExamples", []), /**
   * @generated from field: string limitations = 4;
   */ _define_property(this, "limitations", ""), /**
   * Manually recorded citations/contact/recap text; never dereferenced as authority.
   *
   * @generated from field: repeated string sources = 5;
   */ _define_property(this, "sources", []), /**
   * @generated from field: repeated mono.datagateway.v1.PursuitPPMetric metrics = 6;
   */ _define_property(this, "metrics", []), /**
   * @generated from field: string fit_assessment = 7;
   */ _define_property(this, "fitAssessment", ""), /**
   * @generated from field: repeated mono.datagateway.v1.PursuitPPComparison comparisons = 8;
   */ _define_property(this, "comparisons", []), /**
   * @generated from field: repeated string missing_evidence = 9;
   */ _define_property(this, "missingEvidence", []), /**
   * @generated from field: string follow_up = 10;
   */ _define_property(this, "followUp", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(PursuitPPContent, "runtime", proto3);
_define_property(PursuitPPContent, "typeName", "mono.datagateway.v1.PursuitPPContent");
_define_property(PursuitPPContent, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "narrative",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "outcomes",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "scope_examples",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 4,
            name: "limitations",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "sources",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 6,
            name: "metrics",
            kind: "message",
            T: PursuitPPMetric,
            repeated: true
        },
        {
            no: 7,
            name: "fit_assessment",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "comparisons",
            kind: "message",
            T: PursuitPPComparison,
            repeated: true
        },
        {
            no: 9,
            name: "missing_evidence",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 10,
            name: "follow_up",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * Authorized downstream read contract. Every read rechecks the current caller's
 * audience. Historical revisions retain source lineage but report CURRENT
 * withdrawal/reuse status. Withdrawn material returns metadata only.
 *
 * @generated from message mono.datagateway.v1.PursuitPPView
 */ export class PursuitPPView extends Message {
    static fromBinary(bytes, options) {
        return new PursuitPPView().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PursuitPPView().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PursuitPPView().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(PursuitPPView, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string capture_project_id = 2;
   */ _define_property(this, "captureProjectId", ""), /**
   * @generated from field: string library_item_id = 3;
   */ _define_property(this, "libraryItemId", ""), /**
   * Released sources: pinned Library release version; manual drafts: source item
   * updated_at (RFC3339Nano) at selection, never a claim of release approval.
   *
   * @generated from field: string source_version = 4;
   */ _define_property(this, "sourceVersion", ""), /**
   * @generated from field: string release_id = 5;
   */ _define_property(this, "releaseId", ""), /**
   * @generated from field: string reuse_id = 6;
   */ _define_property(this, "reuseId", ""), /**
   * @generated from field: int32 revision = 7;
   */ _define_property(this, "revision", 0), /**
   * @generated from field: mono.datagateway.v1.PursuitPPContent content = 8;
   */ _define_property(this, "content", void 0), /**
   * manual | source_backed. Source-backed means a pinned release or manually
   * recorded citations, not independently verified claims or reuse approval.
   *
   * @generated from field: string material_kind = 9;
   */ _define_property(this, "materialKind", ""), /**
   * unverified | local_tailoring_unapproved | source_withdrawn
   *
   * @generated from field: string reuse_status = 10;
   */ _define_property(this, "reuseStatus", ""), /**
   * @generated from field: string audience = 11;
   */ _define_property(this, "audience", ""), /**
   * @generated from field: bool source_withdrawn = 12;
   */ _define_property(this, "sourceWithdrawn", false), /**
   * Always false for local tailoring, even when approved source text is present.
   *
   * @generated from field: bool external_use_approved = 13;
   */ _define_property(this, "externalUseApproved", false), /**
   * Only a permissioned released derivative; never raw Library prepared content.
   *
   * @generated from field: string approved_source_content = 14;
   */ _define_property(this, "approvedSourceContent", ""), /**
   * @generated from field: string source_restrictions = 15;
   */ _define_property(this, "sourceRestrictions", ""), /**
   * @generated from field: string selected_by = 16;
   */ _define_property(this, "selectedBy", ""), /**
   * @generated from field: string edited_by = 17;
   */ _define_property(this, "editedBy", ""), /**
   * @generated from field: string created_at = 18;
   */ _define_property(this, "createdAt", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(PursuitPPView, "runtime", proto3);
_define_property(PursuitPPView, "typeName", "mono.datagateway.v1.PursuitPPView");
_define_property(PursuitPPView, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "capture_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "library_item_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "source_version",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "release_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "reuse_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "revision",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 8,
            name: "content",
            kind: "message",
            T: PursuitPPContent
        },
        {
            no: 9,
            name: "material_kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "reuse_status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "audience",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 12,
            name: "source_withdrawn",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 13,
            name: "external_use_approved",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 14,
            name: "approved_source_content",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 15,
            name: "source_restrictions",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 16,
            name: "selected_by",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 17,
            name: "edited_by",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 18,
            name: "created_at",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.SelectPursuitPPRequest
 */ export class SelectPursuitPPRequest extends Message {
    static fromBinary(bytes, options) {
        return new SelectPursuitPPRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SelectPursuitPPRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SelectPursuitPPRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SelectPursuitPPRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string user_id = 2;
   */ _define_property(this, "userId", ""), /**
   * @generated from field: string capture_project_id = 3;
   */ _define_property(this, "captureProjectId", ""), /**
   * @generated from field: string library_item_id = 4;
   */ _define_property(this, "libraryItemId", ""), /**
   * Empty only for an owned, incomplete manual draft; otherwise adopt this release.
   *
   * @generated from field: string release_id = 5;
   */ _define_property(this, "releaseId", ""), /**
   * @generated from field: mono.datagateway.v1.PursuitPPContent content = 6;
   */ _define_property(this, "content", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(SelectPursuitPPRequest, "runtime", proto3);
_define_property(SelectPursuitPPRequest, "typeName", "mono.datagateway.v1.SelectPursuitPPRequest");
_define_property(SelectPursuitPPRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "capture_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "library_item_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "release_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "content",
            kind: "message",
            T: PursuitPPContent
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.RevisePursuitPPRequest
 */ export class RevisePursuitPPRequest extends Message {
    static fromBinary(bytes, options) {
        return new RevisePursuitPPRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RevisePursuitPPRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RevisePursuitPPRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RevisePursuitPPRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string user_id = 2;
   */ _define_property(this, "userId", ""), /**
   * @generated from field: string capture_project_id = 3;
   */ _define_property(this, "captureProjectId", ""), /**
   * @generated from field: string id = 4;
   */ _define_property(this, "id", ""), /**
   * Required optimistic concurrency guard; earlier revisions are append-only.
   *
   * @generated from field: int32 expected_revision = 5;
   */ _define_property(this, "expectedRevision", 0), /**
   * @generated from field: mono.datagateway.v1.PursuitPPContent content = 6;
   */ _define_property(this, "content", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(RevisePursuitPPRequest, "runtime", proto3);
_define_property(RevisePursuitPPRequest, "typeName", "mono.datagateway.v1.RevisePursuitPPRequest");
_define_property(RevisePursuitPPRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "capture_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "expected_revision",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 6,
            name: "content",
            kind: "message",
            T: PursuitPPContent
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.GetPursuitPPRequest
 */ export class GetPursuitPPRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetPursuitPPRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetPursuitPPRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetPursuitPPRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetPursuitPPRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string user_id = 2;
   */ _define_property(this, "userId", ""), /**
   * @generated from field: string capture_project_id = 3;
   */ _define_property(this, "captureProjectId", ""), /**
   * @generated from field: string id = 4;
   */ _define_property(this, "id", ""), /**
   * 0 = latest. Historical reads use CURRENT audience/withdrawal checks.
   *
   * @generated from field: int32 revision = 5;
   */ _define_property(this, "revision", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetPursuitPPRequest, "runtime", proto3);
_define_property(GetPursuitPPRequest, "typeName", "mono.datagateway.v1.GetPursuitPPRequest");
_define_property(GetPursuitPPRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "capture_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "revision",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListPursuitPPRequest
 */ export class ListPursuitPPRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListPursuitPPRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListPursuitPPRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListPursuitPPRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListPursuitPPRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string user_id = 2;
   */ _define_property(this, "userId", ""), /**
   * @generated from field: string capture_project_id = 3;
   */ _define_property(this, "captureProjectId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListPursuitPPRequest, "runtime", proto3);
_define_property(ListPursuitPPRequest, "typeName", "mono.datagateway.v1.ListPursuitPPRequest");
_define_property(ListPursuitPPRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "capture_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.SelectPursuitPPResponse
 */ export class SelectPursuitPPResponse extends Message {
    static fromBinary(bytes, options) {
        return new SelectPursuitPPResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SelectPursuitPPResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SelectPursuitPPResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SelectPursuitPPResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.PursuitPPView selection = 1;
   */ _define_property(this, "selection", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(SelectPursuitPPResponse, "runtime", proto3);
_define_property(SelectPursuitPPResponse, "typeName", "mono.datagateway.v1.SelectPursuitPPResponse");
_define_property(SelectPursuitPPResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "selection",
            kind: "message",
            T: PursuitPPView
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.RevisePursuitPPResponse
 */ export class RevisePursuitPPResponse extends Message {
    static fromBinary(bytes, options) {
        return new RevisePursuitPPResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RevisePursuitPPResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RevisePursuitPPResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RevisePursuitPPResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.PursuitPPView selection = 1;
   */ _define_property(this, "selection", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(RevisePursuitPPResponse, "runtime", proto3);
_define_property(RevisePursuitPPResponse, "typeName", "mono.datagateway.v1.RevisePursuitPPResponse");
_define_property(RevisePursuitPPResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "selection",
            kind: "message",
            T: PursuitPPView
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.GetPursuitPPResponse
 */ export class GetPursuitPPResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetPursuitPPResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetPursuitPPResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetPursuitPPResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetPursuitPPResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.PursuitPPView selection = 1;
   */ _define_property(this, "selection", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetPursuitPPResponse, "runtime", proto3);
_define_property(GetPursuitPPResponse, "typeName", "mono.datagateway.v1.GetPursuitPPResponse");
_define_property(GetPursuitPPResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "selection",
            kind: "message",
            T: PursuitPPView
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListPursuitPPResponse
 */ export class ListPursuitPPResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListPursuitPPResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListPursuitPPResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListPursuitPPResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListPursuitPPResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.datagateway.v1.PursuitPPView selections = 1;
   */ _define_property(this, "selections", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListPursuitPPResponse, "runtime", proto3);
_define_property(ListPursuitPPResponse, "typeName", "mono.datagateway.v1.ListPursuitPPResponse");
_define_property(ListPursuitPPResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "selections",
            kind: "message",
            T: PursuitPPView,
            repeated: true
        }
    ]));
